import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';

export const create =
  (config: ApiConfig) =>
  (payload: { data: any; dataHandle?: string }): Promise<any> =>
    fetchWrapper(
      `${config.endpoint}loader/${payload.dataHandle}`,
      {
        method: 'POST',
        body: JSON.stringify(payload.data),
      },
      config
    );
